export const RestartSecond = ({ width = 16, height = 16 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.9997 2.66659C13.6312 2.66659 13.333 2.96512 13.333 3.33325V4.00225C12.0951 2.35532 10.132 1.33325 7.99967 1.33325C4.86494 1.33325 2.19107 3.46572 1.49774 6.51878C1.41634 6.87785 1.64161 7.23525 2.00034 7.31665C2.05047 7.32805 2.09994 7.33325 2.14874 7.33325C2.45281 7.33325 2.72814 7.12358 2.79847 6.81438C3.35254 4.37232 5.49187 2.66659 7.99967 2.66659C9.92274 2.66659 11.6674 3.71025 12.6092 5.33325H11.333C10.9645 5.33325 10.6663 5.63178 10.6663 5.99992C10.6663 6.36805 10.9645 6.66658 11.333 6.66658H13.9997C14.3681 6.66658 14.6663 6.36805 14.6663 5.99992V3.33325C14.6663 2.96512 14.3681 2.66659 13.9997 2.66659Z"
        fill="white"
        fillOpacity="0.4"
      />
      <path
        d="M1.99967 13.3333C2.36814 13.3333 2.66634 13.0347 2.66634 12.6666V11.9831C3.91087 13.6566 5.85847 14.6666 7.99967 14.6666C11.1344 14.6666 13.8083 12.5341 14.5016 9.48105C14.583 9.12199 14.3577 8.76459 13.999 8.68319C13.6364 8.59952 13.2822 8.82639 13.2008 9.18545C12.6468 11.6275 10.5075 13.3333 7.99967 13.3333C6.07594 13.3333 4.34767 12.3149 3.39427 10.6666H4.66634C5.03481 10.6666 5.33301 10.3681 5.33301 9.99992C5.33301 9.63179 5.03481 9.33325 4.66634 9.33325H1.99967C1.63121 9.33325 1.33301 9.63179 1.33301 9.99992V12.6666C1.33301 13.0347 1.63121 13.3333 1.99967 13.3333Z"
        fill="white"
        fillOpacity="0.4"
      />
    </svg>
  );
};
